import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M14.81 16.393a1 1 0 0 1 .853.769l2.073 9.02 5.896-19.637L5.47 15.243l9.34 1.15zm-.94 1.9 2.441 10.62c.322 1.4 2.253 1.466 2.666.09l6.96-23.178c.35-1.168-.824-2.207-1.908-1.688L2.795 14.307c-1.256.6-.956 2.504.422 2.673l10.654 1.313z" clip-rule="evenodd" stroke="none"></path>';
export var LocationArrowOutlineSVG = function LocationArrowOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LocationArrowOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LocationArrowOutlineSVG);